import { c as _c } from "react/compiler-runtime";
import cssClass from './index.module.scss';
const singular = "persona ha aggiunto l'annuncio ai preferiti";
const plural = "persone hanno aggiunto l'annuncio ai preferiti";
export function FavoriteCounterHeart(t0) {
  const $ = _c(6);
  const {
    value: t1
  } = t0;
  const value = t1 === undefined ? 0 : t1;
  const t2 = `${value} ${value === 1 ? singular : plural}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Heart />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== value) {
    t4 = <span aria-hidden="true" className={`${cssClass["counter-wrapper__number"]}`}>{value}</span>;
    $[1] = value;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t2 || $[4] !== t4) {
    t5 = <div className={cssClass["counter-wrapper"]} aria-label={t2}>{t3}{t4}</div>;
    $[3] = t2;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function Heart() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="#AEB9C6"><path d="M7.973 2.668l-.16-.129C5.542.795 2.537 1.391 1.405 3.926c-1.363 3.052.72 7.033 6.048 10.419.159.101.344.155.532.155h.042c.189 0 .374-.054.533-.156 5.332-3.396 7.406-7.403 6.022-10.466C13.43 1.33 10.412.748 8.147 2.527l-.174.14zm4.848 2.177c.71 1.834-.632 4.535-4.436 7.203l-.38.259-.08-.053C3.802 9.463 2.394 6.62 3.228 4.752c.673-1.506 2.612-1.691 3.986-.014.402.49 1.15.486 1.547-.01 1.37-1.71 3.318-1.537 4.005-.016l.056.133z" transform="translate(-133 -520) translate(16 518) translate(117) translate(0 2)" /></g></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}